import { PreventReload, WindowReload } from "event-definitions"

WindowReload.after.handle((url) => {
    const reloadGuard = PreventReload.call({})
    if (reloadGuard?.prevent) {
        return
    }
    if (url) {
        const ensureReload = new Date().getTime()
        const newLocation = url.includes("?") ? `${url}&_=${ensureReload}` : `${url}?_=${ensureReload}`
        window.location.href = newLocation
    } else {
        window.location.reload(true)
    }
})
